import { useContext } from "react";
import { DContext } from "./context/Datacontext";
import { Routers } from "./Routers";
import Loading from "./features/Loading";
import { Chatbot } from "./features/ChatBot";

export const App = () => {
  const { isAuth } = useContext(DContext);

  if (isAuth === null) {
    return <Loading/>;
  }

  return (
    <div>
      {!isAuth && <Chatbot />}
      <Routers />;
    </div>
  )
};
